/**
 * @generated SignedSource<<bba48df69a2e652f7ddab8ffb358b7f8>>
 * @relayHash 7b012ff21ce36310f8207c612ead4abf
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 7b012ff21ce36310f8207c612ead4abf

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emailId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propositionId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "emailId",
        "variableName": "emailId"
      },
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "sendEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SendEmailMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SendEmailMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "7b012ff21ce36310f8207c612ead4abf",
    "metadata": {},
    "name": "SendEmailMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "3c635e32439fd4074630e1446f4532b7";

export default node;
